const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'USUARIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'USUARIO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome,
                    id_vendedor: item.id_vendedor
                }))
            };

        default:
            return state;
    }
}
